import { USER_CONSTANTS, globalConstants, TOAST_TYPES } from "../../constants";
import { ToastifyService, userService } from "../../services";
import { success } from "./utilities";
import { encryptObject, setItemToStorage } from "../../system";

//This action is called when user click on login
function login(userData, onSuccess) {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));

    userService
      .login(userData)
      .then((response) => {
        const encryptedToken = encryptObject(response.token);
        const encryptedData = encryptObject(response.user);
        const encryptedId = encryptObject(response.user.userTypeId);
        setItemToStorage(process.env.REACT_APP_PAYLOAD, encryptedToken);
        setItemToStorage("encryptedData", encryptedData);
        setItemToStorage("userTypeId", encryptedId);
        dispatch(getProfileData(response.user.id));
        dispatch(
          success(response, USER_CONSTANTS.LOGIN, globalConstants.SUCCESS)
        );
        // Call the callback after success
        if (onSuccess) onSuccess();
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
}

export const updateUserProfile = (data, id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    userService
      .updateUserProfile(data)
      .then((response) => {
        dispatch(getProfileData(id));
        ToastifyService.showSuccess(response)
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getProfileData = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    userService
      .getUserProfile(id)
      .then((response) => {
        dispatch(
          success(response.items, USER_CONSTANTS.PROFILE_DATA)
        );
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

//Function to clear user data and logout
function clearUserData() {
  return userService.logout();
}

//Function to logout
function logout() {
  clearUserData();
}

//Exporting login actions for other files
export const userActions = {
  login,
  clearUserData,
  logout,
  updateUserProfile,
  getProfileData
};
